var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('section',{staticClass:"work-area pt-100 pb-70"},[_c('img',{staticClass:"background",attrs:{"src":"/assets/img/background.jpg"}})])])
}]

export { render, staticRenderFns }